import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BadgeType } from '../../../../../shared/components/badge';

@Component({
  selector: 'py-price-file-category-badge',
  templateUrl: './price-file-category-badge.component.html',
  styleUrls: ['./price-file-category-badge.component.scss'],
  standalone: false,
})
export class PriceFileCategoryBadgeComponent implements OnInit {
  readonly badgeType = BadgeType;

  @Input()
  label: string;

  @Input()
  disabled? = true;

  @Input()
  picked = false;

  @Input()
  toggleBadge? = false;

  @Output()
  pick? = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  select() {
    if (!this.disabled) {
      this.picked = !this.picked;
      this.pick.emit(this.picked);
    }
  }
}
